import { useEffect, useState } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { UNSPECIFIED_FACTORY_NO, userState } from '../states/userState'
import { InitialParameters, User } from '../types/index'
import { setUserToLocalStorage } from '../utils/functions/localStorageManager'
import { loadingState, loadingText } from '../states/loadingState'
import { sleep } from '../utils/functions/commons'
import { auth, provider } from '../firebase'
import { signInWithPopup } from 'firebase/auth'
import { zoomState } from '../states/zoomState'
import { useMediaQuery, useTheme } from '@mui/system'
import { gapi } from 'gapi-script'
import { CLIENT_ID, SCOPES } from '../constants/googleAuth'
import { accessTokenState } from '../states/accessTokenState'
import { REDIRECT_URI_PRODUCTION, REDIRECT_URI_TEST } from '../utils/variables'
import { formatDate } from '../utils/functions/formatting'
import { getEndOfMonth, getStartOfMonth } from '../states/dateState'
// const REDIRECT_URI = "http://localhost:3000";
const REDIRECT_URI = REDIRECT_URI_TEST
// const REDIRECT_URI = REDIRECT_URI_PRODUCTION;

export const useLoginOAuth2 = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [user, setUser] = useRecoilState(userState)
  const setLoadingAnimation = useSetRecoilState(loadingState)
  const setLoadingText = useSetRecoilState(loadingText)
  const setAccessTokenState = useSetRecoilState(accessTokenState)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isIphone = useMediaQuery(theme.breakpoints.down('sm'))
  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: CLIENT_ID,
        scope: SCOPES.join(' '),
        redirect_uri: REDIRECT_URI,
        access_type: 'offline', // リフレッシュトークンを取得するための設定
        prompt: 'consent', // 必ずユーザーに同意を求める
        cookie_policy: 'single_host_origin',
      })
    }
    gapi.load('client:auth2', initClient)
  }, [])
  const login = async () => {
    try {
      setLoading(true)
      setLoadingAnimation(true)
      setLoadingText('ログイン中...')
      //Google認証を実行
      const authInstance = gapi.auth2.getAuthInstance()
      const googleUser = await authInstance.signIn()

      const profile = googleUser.getBasicProfile()
      const authResponse = googleUser.getAuthResponse(true)

      if (!authResponse) {
        // より詳細なエラーメッセージを表示
        window.alert(
          '認証レスポンスが見つかりませんでした。\n詳細: ' +
            JSON.stringify(authResponse, null, 2)
        )
        return 1
      }
      //アクセストークンをセット
      setAccessTokenState(authResponse.access_token)
      const photoURL = profile.getImageUrl() ?? ''
      const displayName = profile.getName() ?? ''
      const email = profile.getEmail() ?? ''
      //Recoilにユーザ情報をセット

      setUser((prevUser: User) => {
        // const newUser: User = { ...prevUser, isAuth: true };
        // デフォルト値を設定
        const defaultInitialParams: InitialParameters = {
          workerSingleForInput: null,
          workersForMultiInput: [],
          workersForList: [],
          factoryNo: [50],
          factoryNoForSingleInput: UNSPECIFIED_FACTORY_NO,
          factoryNoForMultiInput: UNSPECIFIED_FACTORY_NO,
          productNo: '',
          productBno: '',
          productNoForSingleInput: '',
          productBnoForSingleInput: '',
          productNoForMultiInput: '',
          productBnoForMultiInput: '',
          latestUrl: '/',
          construction: 5,
          constructionForSingleInput: 5,
          constructionForMultiInput: 5,
          slipNumberForSingleInput: '0000000',
          slipNumberForMultiInput: '0000000',
          isShowSlipNumber: false,
          productNoForMatrix: '',
          productBnoForMatrix: '',
          constructionForMatrix: 5,
          wokerIdForMatrix: '',
          factoryNoForMatrix: 50,
          isPinned: true,
          zoomLevel: isMobile || isIphone ? '0.75' : '1',
          factoryNoForOutsourcingTo: 50,
          factoryNoForOutsourcingCc: 50,
          fromDate: formatDate(getStartOfMonth(new Date())),
          toDate: formatDate(getEndOfMonth(new Date())),
        }
        const newUser: User = {
          ...prevUser,
          mail: email, //メールアドレス
          photoURL: photoURL, //写真URL
          workerName: displayName, //社員名
          isAuth: true,
          initialParameters: {
            ...prevUser.initialParameters,
            ...defaultInitialParams,

            factoryNo: [50],
          },
        }
        //LocalStorageにユーザ情報をセット
        setUserToLocalStorage(newUser)
        return newUser
      })

      setLoadingAnimation(false)
      setLoadingText('')
      setLoading(false)
      return 0
    } catch (e) {
      const errorMessage =
        e instanceof Error
          ? `エラーが発生しました:\nメッセージ: ${e.message}\nスタックトレース: ${e.stack}`
          : `エラーが発生しました:\n${JSON.stringify(e, null, 2)}`

      window.alert(errorMessage)

      // コンソールにも詳細なエラーを出力
      console.error('ログインエラー:', e)

      setLoadingAnimation(false)
      setLoading(false)
      return 1
    }
  }

  return { login, loading, error }
}
